import React, { useState, useEffect, useRef, createContext, useContext, useCallback, useMemo } from 'react';
import logo from './logo.svg';
import './App.css';
import { RouterProvider, createBrowserRouter, useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
//import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import LinearProgress from '@mui/material/LinearProgress';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import { buildBomRows, consolidateBomRows, getLatestProductionOrderForProduct, getProductOptions } from './bomUtils';



//const socket = new WebSocket("wss://fortnox.synktek.com/")

// Ensures cookie is sent

axios.defaults.withCredentials = true;


//const serverUrl = process.env.REACT_APP_SERVER_URL;
const serverUrl = '/api';

const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [loggedIn, setLoggedIn] = useState(null);
  const [user, setUser] = useState(null);

  const checkLoginState = useCallback(async () => {
    try {
      const { data: { loggedIn: logged_in, user }} = await axios.get(`${serverUrl}/auth/logged_in`);
      setLoggedIn(logged_in);
      user && setUser(user);
    } catch (err) {
      console.error(err);
    }
  }, []);

  useEffect(() => {
    checkLoginState();
  }, [checkLoginState]);

  return (
    <AuthContext.Provider value={{ loggedIn, checkLoginState, user }}>
      {children}
    </AuthContext.Provider>
  );
}







/*try {
  // Get posts from server
//     const response = await axios.get(`${serverUrl}/user/posts`)
  const { data: { posts } } = await axios.get(`${serverUrl}/user/posts`)
//          console.log(response)
//          console.log(posts)
  setPosts(posts);
} catch (err) {
  console.error(err);
}

*/



const WarehouseGrid = () => {
  const rateLimitPerSecond = 5;
  const [rows, setRows] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [error, setError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const hasFetched = useRef(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const handleProcessRowUpdateError = (err) => {
    console.error('Error in processing row update:', err);
    setError(err.message || 'An error occurred while updating the row.');
    setOpenSnackbar(true);
  };

  const processRowUpdate = async (newRow, oldRow) => {
    try {
      const id_masked = newRow.id.toString().replace(/\//g, 'SLASH');
      const response = await fetch(`/api/update/article/${id_masked}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({'oldRow':oldRow,'newRow':newRow}),
      });

      if (!response.ok) {
        handleProcessRowUpdateError('Network response was not ok');
        throw new Error('Network response was not ok');
      }

      const differences = {};
      for (const key in newRow) {
        if (key in oldRow && newRow[key] !== oldRow[key]) {
          differences[key] = [newRow[key], oldRow[key]];
        }
      }
      for (const key in newRow) {
        if (!(key in oldRow)) {
          differences[key] = [newRow[key], ""];
        }
      }
      const updatedRow = { ...newRow };
      for (const key in differences) {
        updatedRow[`cached_${key}`] = false;
      }

      return updatedRow;
    } catch (error) {
      handleProcessRowUpdateError('Error updating row:'+error);
      console.error('Error updating row:', error);
      return oldRow;
    }
  };

  const handleSinglePdfExport = async (row) => {
    try {
      const response = await axios.post('/api/generate-pdf', { data: [row], skip_cover: true });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${row.id}.pdf`;
      link.click();
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const handleSinglePrint = async (row) => {
    try {
      const response = await axios.post('/api/print-pdf', { data: [row], skip_cover: true });
      console.log('Print request sent:', response.data);
    } catch (error) {
      console.error('Error printing:', error);
    }
  };

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    Promise.all([
      fetch('/api/accounts').then(response => response.json()),
      fetch('/api/warehouse').then(response => response.json())
    ]).then(([accountsData, data]) => {
      setAccountOptions(accountsData);

      const fetchWithRetry = async (url, retries = 3) => {
        for (let i = 0; i < retries; i++) {
          try {
            const response = await fetch(url);
            if (response.ok) {
              return await response.json();
            } else if (response.status === 429) {
              await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
            } else {
              throw new Error(`HTTP ${response.status}: ${response.statusText}`);
            }
          } catch (error) {
            if (i === retries - 1) throw error;
            await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
          }
        }
      };

      const fetchDetailsInBatch = (batch) => {
        const promises = batch.map(row => {
          if (!row.id) {
            console.error('Undefined row ID:', row);
            return Promise.resolve(null);
          }
          const id = row.id.toString().replace(/\//g, 'SLASH');
          const fetchPromise = fetchWithRetry(`/api/article/${id}`)
            .then(detailedData => {
              return { ...row, ...detailedData };
            })
            .catch(error => {
              console.error('Error fetching detailed data for row:', row.id, error);
              return { ...row, error: 'Failed to fetch detailed data' };
            });
          return fetchPromise;
        });

        Promise.all(promises).then(detailedRows => {
          setRows(prevRows => {
            let idToObject = {};
            detailedRows.forEach(obj => {
                idToObject[obj.id] = obj;
            });
            const joinedRows = data.map(obj => {
              if (idToObject[obj.id]) {
                  // Preserve existing cache flags while applying fresh detail values
                  const cacheFlags = Object.fromEntries(Object.entries(obj).filter(([key]) => key.startsWith('cached_')));
                  const mergedRow = { ...obj, ...idToObject[obj.id], ...cacheFlags };
                  return mergedRow;
              }
              return obj;
            });
            return joinedRows;
          });
          const nextBatchIndex = data.indexOf(batch[batch.length - 1]) + 1;
          if (nextBatchIndex < data.length) {
            setTimeout(() => {
              fetchDetailsInBatch(data.slice(nextBatchIndex, nextBatchIndex + rateLimitPerSecond));
            }, 1000);
          }
        });
      };

      fetchDetailsInBatch(data.slice(0, rateLimitPerSecond));
    })
    .catch(error => {
      console.error('Error fetching data:', error);
    });
  }, []);

  const columns = [
    { field: 'id', headerName: 'Article Number', width: 150, resizable: true },
    {
      field: 'Description',
      headerName: 'Description',
      width: 250,
      resizable: true,
      editable: true,
    },
    {
      field: 'QuantityInStock',
      headerName: 'Quantity In Stock',
      type: 'number',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_QuantityInStock ? 'cachedCell' : '',
    },
    {
      field: 'DisposableQuantity',
      headerName: 'Disposable Quantity',
      type: 'number',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_DisposableQuantity ? 'cachedCell' : '',
    },
    {
      field: 'ReservedQuantity',
      headerName: 'Reserved Quantity',
      type: 'number',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_ReservedQuantity ? 'cachedCell' : '',
    },
    {
      field: 'PurchasePrice',
      headerName: 'Price',
      type: 'number',
      width: 110,
      resizable: true,
      cellClassName: (params) => params.row.cached_PurchasePrice ? 'cachedCell' : '',
    },
    {
      field: 'StockValue',
      headerName: 'Stock Value',
      type: 'number',
      width: 150,
      resizable: true,
      cellClassName: (params) => params.row.cached_StockValue ? 'cachedCell' : '',
    },
    {
      field: 'pdf',
      headerName: 'PDF',
      width: 80,
      resizable: true,
      renderCell: (params) => (
        <Button onClick={() => handleSinglePdfExport(params.row)}>PDF</Button>
      ),
      disableExport: true,
    },
    {
      field: 'print',
      headerName: 'Print',
      width: 80,
      resizable: true,
      renderCell: (params) => (
        <Button onClick={() => handleSinglePrint(params.row)}>Print</Button>
      ),
      disableExport: true,
    },
    {
      field: 'extra_amt',
      headerName: 'Extra Amount',
      type: 'number',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_extra_amt ? 'cachedCell' : '',
    },
    {
      field: 'place',
      headerName: 'Place',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_place ? 'cachedCell' : '',
    },
    {
      field: 'place_old',
      headerName: 'Place Old',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_place_old ? 'cachedCell' : '',
    },
    {
      field: 'ECCN',
      headerName: 'ECCN',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_ECCN ? 'cachedCell' : '',
    },
    {
      field: 'HTSUS',
      headerName: 'HTSUS',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_HTSUS ? 'cachedCell' : '',
    },
    {
      field: 'COO',
      headerName: 'COO',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_COO ? 'cachedCell' : '',
    },
    {
      field: 'StockAccount',
      headerName: 'Accnt',
      width: 110,
      resizable: true,
      editable: true,
      type: 'singleSelect',
      valueOptions: accountOptions,
      disableExport: true,
      cellClassName: (params) => params.row.cached_StockAccount ? 'cachedCell' : '',
    },
    {
      field: 'StockChangeAccount',
      headerName: 'Change accnt',
      width: 110,
      resizable: true,
      editable: true,
      type: 'singleSelect',
      valueOptions: accountOptions,
      disableExport: true,
      cellClassName: (params) => params.row.cached_StockChangeAccount ? 'cachedCell' : '',
    },
    {
      field: 'comptype',
      headerName: 'Type',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_comptype ? 'cachedCell' : '',
    },
    {
      field: 'value',
      headerName: 'Value',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_value ? 'cachedCell' : '',
    },
    {
      field: 'case',
      headerName: 'Case',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_case ? 'cachedCell' : '',
    },
    {
      field: 'rating',
      headerName: 'Rating',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_rating ? 'cachedCell' : '',
    },
    {
      field: 'precision',
      headerName: 'Precision',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_precision ? 'cachedCell' : '',
    },
    {
      field: 'drift',
      headerName: 'Drift',
      width: 110,
      resizable: true,
      editable: true,
      cellClassName: (params) => params.row.cached_drift ? 'cachedCell' : '',
    },
  ];
  
  return (
    <Box sx={{ height: '90%', width: '100%' }}>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
      <DataGrid
        rows={rows}
        columns={columns}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={handleProcessRowUpdateError}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
        slots={{ toolbar: GridToolbar }}
        slotProps={{ toolbar: { csvOptions: { allColumns: true } } }}
      />
    </Box>
  );
};

const WarehousePage = () => {
  const { loggedIn } = useContext(AuthContext);

  useEffect(() => {
    document.title = 'Articles - Fortnox';
  }, []);

  if (loggedIn === false) return <Login />;

  return (
    <>
      <h3>Articles</h3>
      <WarehouseGrid />
    </>
  );
};


const MissingComponents = () => {
  const { loggedIn } = useContext(AuthContext);
  const [rows, setRows] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [orderPlanning, setOrderPlanning] = useState({});
  const [isRecalculating, setIsRecalculating] = useState(false);
  const [progress, setProgress] = useState(0);
  const [progressMessage, setProgressMessage] = useState('');
  const [error, setError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [purchaseOrders, setPurchaseOrders] = useState([]);
  const [selectedPOBySupplier, setSelectedPOBySupplier] = useState({});
  const [selectedRows, setSelectedRows] = useState([]);
  const [isCreatingPO, setIsCreatingPO] = useState(null);
  const [sortModel, setSortModel] = useState([]);
  const [basketAlert, setBasketAlert] = useState(null);

  const fetchSuppliers = () => {
    fetch('/api/suppliers')
      .then(response => response.json())
      .then(data => {
        setSuppliers(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        console.error('Error fetching suppliers:', error);
      });
  };

  const fetchPurchaseOrders = () => {
    fetch('/api/warehouse/purchaseorders/list')
      .then(r => r.json())
      .then(data => setPurchaseOrders(Array.isArray(data) ? data : []))
      .catch(err => console.error('Error fetching purchase orders:', err));
  };

  const fetchMissingComponents = () => {
    fetch('/api/warehouse/missingcomponents')
      .then(response => response.json())
      .then(data => {
        setRows(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };

  const fetchOrderPlanning = () => {
    fetch('/api/warehouse/orderplanning')
      .then(response => response.json())
      .then(data => {
        const planningMap = {};
        if (Array.isArray(data)) {
          data.forEach(plan => {
            planningMap[plan.ArticleNumber] = plan;
          });
        }
        setOrderPlanning(planningMap);
      })
      .catch(error => {
        console.error('Error fetching order planning:', error);
      });
  };

  // Merge orderPlanning data into rows for display
  const getEnrichedRows = () => {
    return rows.map(row => ({
      ...row,
      orderAmount: orderPlanning[row.ArticleNumber]?.amount || 0,
      supplier: orderPlanning[row.ArticleNumber]?.supplier_id || '',
      supplierOrderNumber: orderPlanning[row.ArticleNumber]?.supplier_order_number || '',
      pricePerUnit: orderPlanning[row.ArticleNumber]?.price || 0,
      supplierCurrency: orderPlanning[row.ArticleNumber]?.supplier_currency || '',
      planComment: orderPlanning[row.ArticleNumber]?.comment || '',
    }));
  };

  useEffect(() => {
    if (loggedIn !== true) return;
    document.title = 'Missing Components - Fortnox';
  }, [loggedIn]);

  useEffect(() => {
    if (loggedIn !== true) return;
    fetchSuppliers();
    fetchMissingComponents();
    fetchOrderPlanning();
    fetchPurchaseOrders();
  }, [loggedIn]);

  const saveOrderPlanning = (articleNumber, updateData) => {
    const data = {
      ArticleNumber: articleNumber,
      ...(orderPlanning[articleNumber] || {}),
      ...updateData
    };

    fetch('/api/warehouse/orderplanning', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(result => {
        setOrderPlanning(prev => ({
          ...prev,
          [articleNumber]: result
        }));
      })
      .catch(error => {
        console.error('Error saving order planning:', error);
        setError('Failed to save order planning data');
        setOpenSnackbar(true);
      });
  };

  const handleCellEdit = (params) => {
    const { id, field, value } = params;
    const article = rows.find(r => r.id === id);
    
    if (!article) return;

    const mapping = {
      orderAmount: 'amount',
      supplier: 'supplier_id',
      pricePerUnit: 'price',
      planComment: 'comment'
    };

    if (mapping[field]) {
      saveOrderPlanning(article.ArticleNumber, {
        [mapping[field]]: value
      });
    }
  };

  const processOrderPlanningRowUpdate = async (newRow, oldRow) => {
    const { id } = newRow;
    const article = rows.find(r => r.id === id);
    
    if (!article) return oldRow;

    const mapping = {
      orderAmount: 'amount',
      supplier: 'supplier_id',
      supplierOrderNumber: 'supplier_order_number',
      pricePerUnit: 'price',
      planComment: 'comment'
    };

    // Find which field changed
    let changedField = null;
    let newValue = null;
    for (const field of Object.keys(mapping)) {
      const oldValue = oldRow[field];
      const newValue_tmp = newRow[field];
      if (oldValue !== newValue_tmp) {
        changedField = field;
        newValue = newValue_tmp;
        break;
      }
    }

    if (!changedField) return oldRow;

    try {
      let processedValue = newValue;
      if (changedField === 'supplier') {
        processedValue = String(newValue);
      } else if (changedField === 'pricePerUnit') {
        processedValue = parseFloat(String(newValue).replace(',', '.'));
      }
      const updateData = {
        [mapping[changedField]]: processedValue
      };

      // If supplier changed, also get and save the currency
      if (changedField === 'supplier') {
        const selectedSupplier = suppliers.find(s => s.id === String(newValue));
        if (selectedSupplier) {
          updateData['supplier_currency'] = selectedSupplier.currency;
        }
      }

      const data = {
        ArticleNumber: article.ArticleNumber,
        ...(orderPlanning[article.ArticleNumber] || {}),
        ...updateData
      };

      const response = await fetch('/api/warehouse/orderplanning', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
      });

      if (!response.ok) {
        throw new Error('Failed to save order planning data');
      }

      const result = await response.json();
      
      // Update orderPlanning state
      setOrderPlanning(prev => ({
        ...prev,
        [article.ArticleNumber]: result
      }));

      // Return the updated row with actual saved values
      return newRow;
    } catch (error) {
      console.error('Error saving order planning:', error);
      setError('Failed to save order planning data');
      setOpenSnackbar(true);
      return oldRow;
    }
  };

  const getOrderPlanValue = (articleNumber, field) => {
    const plan = orderPlanning[articleNumber];
    const mapping = {
      orderAmount: 'amount',
      supplier: 'supplier_id',
      pricePerUnit: 'price',
      planComment: 'comment'
    };
    return plan ? plan[mapping[field]] : null;
  };

  const handleRecalculate = async () => {
    setIsRecalculating(true);
    setProgress(0);
    setProgressMessage('Starting recalculation...');
    setError('');

    try {
      const eventSource = new EventSource('/api/warehouse/recalculate-missingcomponents');

      eventSource.addEventListener('message', (event) => {
        try {
          const data = JSON.parse(event.data);

          if (data.error) {
            console.error('Backend error received:', data.error);
            eventSource.close();
            setIsRecalculating(false);
            setError(data.error);
            setOpenSnackbar(true);
            return;
          }

          // Update progress
          setProgress(data.progress || 0);
          setProgressMessage(data.message || '');

          // Check if done
          if (data.done) {
            eventSource.close();
            setIsRecalculating(false);
            // Refresh the missing components table
            fetchMissingComponents();
          }
        } catch (err) {
          console.error('Error parsing SSE data:', err);
          console.error('Raw event data:', event.data);
          eventSource.close();
          setIsRecalculating(false);
          setError(`Failed to parse server response: ${err.message}`);
          setOpenSnackbar(true);
        }
      });

      eventSource.addEventListener('error', (event) => {
        console.error('SSE Connection Error:', event);
        console.error('EventSource readyState:', event.target.readyState);
        eventSource.close();
        setIsRecalculating(false);
        setError('Connection lost during recalculation. Check browser console for details.');
        setOpenSnackbar(true);
      });
    } catch (err) {
      console.error('Error starting recalculation:', err);
      setError(err.message || 'An error occurred during recalculation');
      setOpenSnackbar(true);
      setIsRecalculating(false);
      setProgress(0);
      setProgressMessage('');
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const buildSortedSelectedRows = () => {
    const enriched = getEnrichedRows();
    const selected = enriched.filter(r => selectedRows.includes(r.id));
    if (sortModel.length === 0) return selected;
    const { field, sort } = sortModel[0];
    const col = columns.find(c => c.field === field);
    return [...selected].sort((a, b) => {
      let aVal = col?.valueGetter ? col.valueGetter({ row: a, field, colDef: col }) : a[field];
      let bVal = col?.valueGetter ? col.valueGetter({ row: b, field, colDef: col }) : b[field];
      if (col?.sortComparator) return sort === 'asc' ? col.sortComparator(aVal, bVal) : col.sortComparator(bVal, aVal);
      if (aVal == null) aVal = '';
      if (bVal == null) bVal = '';
      if (typeof aVal === 'number' && typeof bVal === 'number') return sort === 'asc' ? aVal - bVal : bVal - aVal;
      return sort === 'asc' ? String(aVal).localeCompare(String(bVal)) : String(bVal).localeCompare(String(aVal));
    });
  };

  const handleExportBasket = (fieldOrder) => {
    const exportRows = buildSortedSelectedRows();
    if (exportRows.length === 0) {
      setBasketAlert({ severity: 'warning', message: 'No rows selected. Please select at least one row to export.' });
      return;
    }
    const csv = exportRows.map(r => fieldOrder.map(f => r[f] ?? '').join(',')).join('\n');
    navigator.clipboard.writeText(csv);
    setBasketAlert({ severity: 'success', message: csv });
  };

  const handleExportDigikeyBasket = () => handleExportBasket(['orderAmount', 'supplierOrderNumber']);
  const handleExportFarnellBasket = () => handleExportBasket(['supplierOrderNumber', 'orderAmount']);

  const handleCreatePO = async (supplierId) => {
    const poId = selectedPOBySupplier[supplierId] ?? 'new';
    const enriched = getEnrichedRows();

    const candidates = selectedRows.length > 0
      ? enriched.filter(r => selectedRows.includes(r.id) && r.supplier === supplierId)
      : enriched.filter(r => r.supplier === supplierId);

    if (candidates.length === 0) {
      setError('No components found for this supplier (check your selection)');
      setOpenSnackbar(true);
      return;
    }

    const items = candidates.map(r => {
      const quantityToOrder = Math.max(0, (r.TotalMissing || 0) - (r.QuantityInProduction || 0) - (r.QuantityInProcurement || 0));
      return {
        ArticleNumber: r.ArticleNumber,
        quantity: r.orderAmount > 0 ? r.orderAmount : quantityToOrder,
        price: r.pricePerUnit || 0,
        currency: r.supplierCurrency || '',
      };
    });

    setIsCreatingPO(supplierId);
    try {
      const response = await fetch('/api/warehouse/create-purchaseorder', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          supplier_id: supplierId,
          order_id: poId === 'new' ? null : poId,
          items,
        }),
      });
      const result = await response.json();
      if (!response.ok || result.error) {
        setError(result.message || 'Failed to create/update purchase order');
        setOpenSnackbar(true);
      } else {
        setProgressMessage(`Purchase order ${result.id || ''} created/updated successfully`);
        fetchPurchaseOrders();
      }
    } catch (err) {
      setError('Failed to create/update purchase order');
      setOpenSnackbar(true);
    } finally {
      setIsCreatingPO(null);
    }
  };

  if (loggedIn === false) return <Login />;

  const columns = [
    {
      field: 'ArticleNumber',
      headerName: 'Article Number',
      width: 200,
      resizable: true,
      renderCell: (params) => (
        <a href={`https://octopart.com/search?currency=EUR&specs=0&start=0&q=${params.value}&s=1&distributor_id=459&distributor_id=2401&distributor_id=3261&distributor_id=819&distributor_id=15283&distributor_id=11039&distributor_id=1532&distributor_id=1106&distributor_id=4617`} target="_blank" rel="noopener noreferrer">
          {params.value}
        </a>
      ),
    },
    {
      field: 'TotalMissing',
      headerName: 'Total Missing Qty',
      type: 'number',
      width: 100,
      resizable: true,
    },
    {
      field: 'TotalRequired',
      headerName: 'Total Required Qty',
      type: 'number',
      width: 100,
      resizable: true,
    },
    {
      field: 'QuantityInProduction',
      headerName: 'Qty in Production',
      type: 'number',
      width: 100,
      resizable: true,
    },
    {
      field: 'QuantityInProcurement',
      headerName: 'Qty in Procurement',
      type: 'number',
      width: 100,
      resizable: true,
    },
    {
      field: 'QuantityToOrder',
      headerName: 'Qty to Order',
      type: 'number',
      width: 100,
      resizable: true,
      valueGetter: (params) => {
        const missing = params.row.TotalMissing || 0;
        const inProd = params.row.QuantityInProduction || 0;
        const inProcurement = params.row.QuantityInProcurement || 0;
        return Math.max(0, missing - inProd - inProcurement);
      },
    },
    {
      field: 'ProductionOrdersCount',
      headerName: 'PO Count',
      type: 'number',
      width: 80,
      resizable: true,
    },
    {
      field: 'ProductionOrders',
      headerName: 'Production Order Numbers',
      width: 100,
      resizable: true,
      renderCell: (params) => (
        <div>
          {params.value && params.value.map((po, index) => (
            <span key={index}>
              <a href={`/warehouse/productionorder/${po}`}>
                {po}
              </a>
              {index < params.value.length - 1 ? ', ' : ''}
            </span>
          ))}
        </div>
      ),
    },
    {
      field: 'orderAmount',
      headerName: 'Order Amount',
      type: 'number',
      width: 100,
      resizable: true,
      editable: true,
    },
    {
      field: 'supplier',
      headerName: 'Supplier',
      width: 150,
      resizable: true,
      editable: true,
      type: 'singleSelect',
      valueOptions: suppliers
        .slice()
        .sort((a, b) => a.name.localeCompare(b.name))
        .map(s => ({ value: s.id, label: s.name })),
    },
    {
      field: 'supplierOrderNumber',
      headerName: 'Supplier Order #',
      width: 150,
      resizable: true,
      editable: true,
    },
    {
      field: 'supplierCurrency',
      headerName: 'Currency',
      width: 70,
      resizable: true,
      editable: false,
    },
    {
      field: 'pricePerUnit',
      headerName: 'Price per Unit',
      width: 100,
      resizable: true,
      editable: true,
      valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(4) : '',
      sortComparator: (v1, v2) => (Number(v1) || 0) - (Number(v2) || 0),
    },
    {
      field: 'totalAmount',
      headerName: 'Total Amount',
      type: 'number',
      width: 120,
      resizable: true,
      editable: false,
      valueGetter: (params) => {
        const amount = params.row.orderAmount || 0;
        const price = params.row.pricePerUnit || 0;
        return amount * price;
      },
    },
    {
      field: 'planComment',
      headerName: 'Comment',
      width: 200,
      resizable: true,
      editable: true,
    },
  ];

  // Calculate supplier totals
  const getSupplierTotals = () => {
    const totals = {};

    Object.values(orderPlanning).forEach(plan => {
      if (plan.supplier_id && plan.amount && plan.price) {
        const supplierId = plan.supplier_id;
        const totalValue = plan.amount * plan.price;

        if (!totals[supplierId]) {
          totals[supplierId] = {
            id: supplierId,
            supplier: '',
            totalValue: 0,
            currency: '',
            count: 0,
          };
        }
        totals[supplierId].totalValue += totalValue;
        totals[supplierId].currency = plan.supplier_currency || '';
        totals[supplierId].count += 1;
      }
    });

    // Map supplier names
    return Object.values(totals).map(total => {
      const supplier = suppliers.find(s => s.id === total.id);
      return {
        ...total,
        supplier: supplier ? supplier.name : `Unknown (${total.id})`,
      };
    }).sort((a, b) => b.totalValue - a.totalValue);
  };

  const supplierTotalColumns = [
    {
      field: 'supplier',
      headerName: 'Supplier',
      width: 200,
      resizable: true,
      flex: 1,
    },
    {
      field: 'count',
      headerName: 'Items',
      type: 'number',
      width: 80,
      resizable: true,
    },
    {
      field: 'totalValue',
      headerName: 'Total Order Value',
      type: 'number',
      width: 150,
      resizable: true,
      valueFormatter: (params) => {
        return typeof params.value === 'number' ? params.value.toFixed(2) : params.value;
      },
    },
    {
      field: 'currency',
      headerName: 'Currency',
      width: 100,
      resizable: true,
    },
    {
      field: 'actions',
      headerName: '',
      width: 380,
      sortable: false,
      renderCell: (params) => {
        const supplierId = params.row.id;
        const supplierPOs = purchaseOrders.filter(po => po.supplierNumber === supplierId);
        const selectedPO = selectedPOBySupplier[supplierId] ?? 'new';
        const loading = isCreatingPO === supplierId;
        return (
          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <FormControl size="small" sx={{ minWidth: 180 }}>
              <Select
                value={selectedPO}
                onChange={(e) => setSelectedPOBySupplier(prev => ({ ...prev, [supplierId]: e.target.value }))}
                displayEmpty
              >
                <MenuItem value="new">New order</MenuItem>
                {supplierPOs.map(po => (
                  <MenuItem key={po.id} value={po.id}>
                    #{po.id} — {po.orderDate} ({po.purchaseOrderState})
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              size="small"
              onClick={() => handleCreatePO(supplierId)}
              disabled={loading}
              startIcon={loading ? <CircularProgress size={14} /> : null}
            >
              {loading ? 'Creating…' : 'Create/Update PO'}
            </Button>
          </Box>
        );
      },
    },
  ];

  return (
    <>
      <h3>Missing Components</h3>
      <Box sx={{ marginBottom: '30px', width: '90%' }}>
        <h4>Supplier Order Totals</h4>
        <Box sx={{ height: 'auto', width: '100%', maxHeight: '400px' }}>
          <DataGrid
            rows={getSupplierTotals()}
            columns={supplierTotalColumns}
            rowHeight={52}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 10,
                },
              },
            }}
            pageSizeOptions={[5, 10]}
            disableRowSelectionOnClick
            density="compact"
            sx={{
              backgroundColor: '#f5f5f5',
              border: '1px solid #ddd',
            }}
          />
        </Box>
      </Box>
      <Box sx={{ marginBottom: '20px', display: 'flex', gap: '10px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          color="primary"
          onClick={handleRecalculate}
          disabled={isRecalculating}
        >
          {isRecalculating ? 'Recalculating...' : 'Recalculate Missing Components'}
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleExportDigikeyBasket}
        >
          Export Digikey Basket
        </Button>
        <Button
          variant="contained"
          color="secondary"
          onClick={handleExportFarnellBasket}
        >
          Export Farnell/RS Basket
        </Button>
        {isRecalculating && (
          <Box sx={{ marginTop: '10px', marginBottom: '10px' }}>
            <LinearProgress variant="determinate" value={progress} />
            <Typography variant="body2" sx={{ marginTop: '5px' }}>
              {progressMessage}
            </Typography>
          </Box>
        )}
        {!isRecalculating && progressMessage && (
          <Typography variant="body2" sx={{ marginTop: '5px', color: 'green' }}>
            {progressMessage}
          </Typography>
        )}
      </Box>
      <Box sx={{ height: '90%', width: '90%' }}>
        <Snackbar
          open={openSnackbar}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
        >
          <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>
        <Snackbar
          open={basketAlert !== null}
          autoHideDuration={basketAlert?.severity === 'success' ? 8000 : 5000}
          onClose={() => setBasketAlert(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setBasketAlert(null)} severity={basketAlert?.severity ?? 'info'} sx={{ width: '100%' }}>
            {basketAlert?.severity === 'success'
              ? <><strong>Copied to clipboard:</strong><pre style={{ margin: '4px 0 0', whiteSpace: 'pre-wrap', fontFamily: 'monospace' }}>{basketAlert.message}</pre></>
              : basketAlert?.message}
          </Alert>
        </Snackbar>
        <DataGrid
          rows={getEnrichedRows()}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 50,
              },
            },
          }}
          pageSizeOptions={[5]}
          checkboxSelection
          disableRowSelectionOnClick
          rowSelectionModel={selectedRows}
          onRowSelectionModelChange={(newSelection) => setSelectedRows(newSelection)}
          sortModel={sortModel}
          onSortModelChange={setSortModel}
          processRowUpdate={processOrderPlanningRowUpdate}
          onProcessRowUpdateError={(error) => {
            console.error('Error processing row update:', error);
          }}
          sx={{
            '& .MuiDataGrid-columnSeparator': {
              visibility: 'visible',
              opacity: 0.5,
            },
            '& .MuiDataGrid-columnSeparator:hover': {
              opacity: 1,
            },
            '& .MuiDataGrid-columnHeaders': {
              overflow: 'visible',
            },
            '& .MuiDataGrid-columnHeader': {
              overflow: 'visible',
            },
          }}
        />
      </Box>
    </>
  );
};

const BomPage = () => {
  const { loggedIn } = useContext(AuthContext);
  const [productOptions, setProductOptions] = useState([]);
  const [orders, setOrders] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [baseBomRows, setBaseBomRows] = useState([]);
  const [bomRows, setBomRows] = useState([]);
  const [recursive, setRecursive] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleBomRowUpdate = useCallback(async (newRow, oldRow) => {
    const updatedRow = { ...newRow };

    if (newRow.price != null && newRow.price !== '' && newRow.quantity != null) {
      updatedRow.extendedPrice = Number(newRow.quantity || 0) * Number(newRow.price || 0);
    }

    const changedKeys = Object.keys(newRow).filter((key) => key in oldRow && newRow[key] !== oldRow[key]);
    const customEditableFields = ['place', 'ECCN', 'HTSUS', 'COO'];
    const hasPersistedFieldChange = changedKeys.some((key) => customEditableFields.includes(key));

    if (hasPersistedFieldChange) {
      try {
        const payloadNewRow = { ...newRow };
        delete payloadNewRow.extendedPrice;
        delete payloadNewRow.productionOrderNumber;
        const response = await fetch(`/api/update/article/${String(newRow.id).replace(/\//g, 'SLASH')}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ oldRow, newRow: payloadNewRow }),
        });

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(errorText || 'Failed to update BOM row');
        }
      } catch (err) {
        console.error('Error updating BOM row:', err);
        setError(err.message || 'Failed to update BOM row');
        return oldRow;
      }
    }

    setBomRows((prevRows) => prevRows.map((row) => {
      if (row.id !== oldRow.id || row.productionOrderNumber !== oldRow.productionOrderNumber || row.quantity !== oldRow.quantity) {
        return row;
      }

      return updatedRow;
    }));

    setBaseBomRows((prevRows) => prevRows.map((row) => {
      if (row.id !== oldRow.id || row.productionOrderNumber !== oldRow.productionOrderNumber || row.quantity !== oldRow.quantity) {
        return row;
      }

      return updatedRow;
    }));

    return updatedRow;
  }, []);

  const normalizeBomRow = (row, orderId, quantityValue) => ({
    ...row,
    id: String(row.id || row.itemId || row.ItemId || '').trim(),
    Description: row.Description || row.itemDescription || row.description || '',
    productionOrderNumber: String(orderId),
    quantity: Number(quantityValue || 0),
    place: row.place || row.Place || '',
    ECCN: row.ECCN || '',
    HTSUS: row.HTSUS || '',
    COO: row.COO || '',
    price: row.price ?? row.PurchasePrice ?? row.purchasePrice ?? '',
  });

  const normalizeOrderRows = (orderRows, orderId) => {
    return (orderRows || []).map((row) => {
      const quantityValue = Number(row.quantityRequired ?? row.totalQuantityRequired ?? row.quantity ?? 0);
      return normalizeBomRow(row, orderId, quantityValue);
    });
  };

  const buildRecursiveLookup = async (articleIds) => {
    const lookup = {};
    const visited = new Set();

    const loadChildren = async (articleId) => {
      if (!articleId || visited.has(articleId)) return;
      visited.add(articleId);

      const childOrder = getLatestProductionOrderForProduct(orders, articleId);
      if (!childOrder) return;

      const childResponse = await fetch(`/api/warehouse/productionorder/${childOrder.id || childOrder.Id}`);
      const childData = await childResponse.json();
      const childRows = normalizeOrderRows(Array.isArray(childData?.packageItems) ? childData.packageItems : [], childOrder.id || childOrder.Id);
      lookup[articleId] = { rows: childRows };

      await Promise.all(childRows.map((childRow) => loadChildren(childRow.id)));
    };

    await Promise.all(articleIds.map((articleId) => loadChildren(articleId)));
    return lookup;
  };

  useEffect(() => {
    if (loggedIn !== true) return;
    document.title = 'BOM - Fortnox';

    fetch('/api/warehouse/productionorders')
      .then((response) => response.json())
      .then((data) => {
        const orderList = Array.isArray(data)
          ? data
          : (data?.ProductionOrders || data?.rows || []);
        const normalizedOrders = (orderList || []).filter((order) => {
          const state = String(order?.documentState || order?.productionState || '').toLowerCase();
          return state !== 'voided';
        });
        setOrders(normalizedOrders);
        setProductOptions(getProductOptions(normalizedOrders));
      })
      .catch((err) => {
        console.error('Error fetching production orders:', err);
        setError('Failed to load production orders');
      });
  }, [loggedIn]);

  useEffect(() => {
    let cancelled = false;

    if (!selectedProduct) {
      setBaseBomRows([]);
      setBomRows([]);
      setSelectedOrder(null);
      return undefined;
    }

    const loadBom = async () => {
      const latestOrder = getLatestProductionOrderForProduct(orders, selectedProduct);
      if (!latestOrder) {
        setBaseBomRows([]);
        setBomRows([]);
        setSelectedOrder(null);
        return;
      }

      setLoading(true);
      setError('');

      try {
        const orderId = latestOrder.id || latestOrder.Id;
        const response = await fetch(`/api/warehouse/productionorder/${orderId}`);
        const data = await response.json();

        if (cancelled) return;

        const rawRows = Array.isArray(data?.packageItems) ? data.packageItems : [];
        const normalizedRows = normalizeOrderRows(rawRows, orderId);

        setBaseBomRows(normalizedRows);
        setSelectedOrder({ orderNumber: orderId, productId: selectedProduct });

        if (!recursive) {
          setBomRows(consolidateBomRows(normalizedRows));
          return;
        }

        const targets = Array.from(new Set(normalizedRows.map((row) => row.id).filter(Boolean)));
        const lookup = targets.length > 0 ? await buildRecursiveLookup(targets) : {};

        if (!cancelled) {
          const expandedRows = buildBomRows({ rows: normalizedRows, productOrderLookup: lookup, recursive: true });
          setBomRows(consolidateBomRows(expandedRows));
        }
      } catch (err) {
        console.error('Error loading BOM:', err);
        if (!cancelled) {
          setError('Failed to load BOM data');
          setBomRows([]);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    loadBom();

    return () => {
      cancelled = true;
    };
  }, [orders, recursive, selectedProduct]);

  const costSummaryMatrix = useMemo(() => {
    const normalizeValue = (value) => {
      const trimmed = String(value || '').trim();
      return trimmed || 'unknown';
    };

    const cooValues = Array.from(new Set(bomRows.map((row) => normalizeValue(row.COO)).filter(Boolean))).sort();
    const eccnValues = Array.from(new Set(bomRows.map((row) => normalizeValue(row.ECCN)).filter(Boolean))).sort();
    const matrixRows = [];

    cooValues.forEach((coo) => {
      const rowData = { id: `coo-${coo}`, COO: coo };
      let rowTotal = 0;

      eccnValues.forEach((eccn) => {
        const value = bomRows
          .filter((item) => normalizeValue(item.COO) === coo && normalizeValue(item.ECCN) === eccn)
          .reduce((sum, item) => {
            const extendedValue = item.extendedPrice != null && item.extendedPrice !== ''
              ? Number(item.extendedPrice || 0)
              : Number(item.quantity || 0) * Number(item.price || 0);
            return sum + extendedValue;
          }, 0);

        rowData[`ECCN_${eccn}`] = value;
        rowTotal += value;
      });

      rowData.rowTotal = rowTotal;
      matrixRows.push(rowData);
    });

    const totalsRow = { id: '__totals__', COO: 'Total' };
    let overallTotal = 0;

    eccnValues.forEach((eccn) => {
      const colTotal = matrixRows.reduce((sum, row) => sum + Number(row[`ECCN_${eccn}`] || 0), 0);
      totalsRow[`ECCN_${eccn}`] = colTotal;
      overallTotal += colTotal;
    });

    totalsRow.rowTotal = overallTotal;
    matrixRows.push(totalsRow);

    return { rows: matrixRows, eccnValues, cooValues, totalCost: overallTotal };
  }, [bomRows]);

  const costSummaryPercentMatrix = useMemo(() => {
    const { rows, eccnValues, totalCost } = costSummaryMatrix;

    if (!totalCost) {
      return { rows: [], eccnValues, totalCost: 0 };
    }

    return {
      rows: rows.map((row) => {
        const nextRow = { ...row };
        eccnValues.forEach((eccn) => {
          const key = `ECCN_${eccn}`;
          nextRow[key] = Number(row[key] || 0) / totalCost * 100;
        });

        if (typeof row.rowTotal === 'number') {
          nextRow.rowTotal = Number(row.rowTotal || 0) / totalCost * 100;
        }

        return nextRow;
      }),
      eccnValues,
      totalCost,
    };
  }, [costSummaryMatrix]);

  const columns = [
    { field: 'id', headerName: 'ID', width: 180, resizable: true },
    { field: 'Description', headerName: 'Description', width: 320, resizable: true },
    { field: 'productionOrderNumber', headerName: 'Production Order Number', width: 180, resizable: true },
    { field: 'quantity', headerName: 'Quantity', width: 120, type: 'number', resizable: true, editable: true, valueFormatter: (params) => Number(params.value || 0).toFixed(4) },
    { field: 'place', headerName: 'Place', width: 120, resizable: true, editable: true },
    { field: 'QuantityInStock', headerName: 'In Stock', width: 100, type: 'number', resizable: true },
    { field: 'ECCN', headerName: 'ECCN', width: 120, resizable: true, editable: true },
    { field: 'HTSUS', headerName: 'HTSUS', width: 120, resizable: true, editable: true },
    { field: 'COO', headerName: 'COO', width: 120, resizable: true, editable: true },
    { field: 'price', headerName: 'Price', width: 120, resizable: true, editable: true, valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(2) : '' },
    { field: 'extendedPrice', headerName: 'Extended Price', width: 140, resizable: true, editable: false, valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(2) : '' },
    {
      field: 'print',
      headerName: 'Print',
      width: 80,
      resizable: true,
      sortable: false,
      renderCell: (params) => (
        <Button onClick={() => handleBomRowPrint(params.row)}>Print</Button>
      ),
      disableExport: true,
    },
  ];

  const handleBomRowPrint = async (row) => {
    try {
      const labelRow = { ...row, documentid: row.productionOrderNumber };
      const response = await axios.post('/api/print-pdf', { data: [labelRow], skip_cover: true });
      console.log('Print request sent:', response.data);
    } catch (err) {
      console.error('Error printing:', err);
      setError(err?.response?.data?.error || 'Failed to print label');
    }
  };

  return (
    <Box sx={{ width: '100%' }}>
      <h3>BOM</h3>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 2, flexWrap: 'wrap' }}>
        <FormControl sx={{ minWidth: 280 }}>
          <label htmlFor="bom-product-select" style={{ marginBottom: 6 }}>Product with production order</label>
          <Select
            id="bom-product-select"
            value={selectedProduct}
            onChange={(event) => setSelectedProduct(event.target.value)}
            displayEmpty
          >
            <MenuItem value=""><em>Select a product</em></MenuItem>
            {productOptions.map((option) => (
              <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControlLabel
          control={<Checkbox checked={recursive} onChange={(event) => setRecursive(event.target.checked)} />}
          label="Replace subassemblies recursively"
        />
      </Box>
      {error ? <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert> : null}
      {loading ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <CircularProgress size={20} />
          <span>Loading BOM…</span>
        </Box>
      ) : null}
      {selectedOrder ? (
        <Typography variant="body2" sx={{ mb: 1 }}>
          Showing BOM for latest production order {selectedOrder.orderNumber} for {selectedOrder.productId}.
        </Typography>
      ) : null}
      <Box sx={{ height: 600, width: '100%' }}>
        <DataGrid
          rows={bomRows}
          columns={columns}
          getRowId={(row) => `${row.id}-${row.productionOrderNumber}-${row.quantity}`}
          initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
          pageSizeOptions={[25, 50]}
          disableRowSelectionOnClick
          processRowUpdate={handleBomRowUpdate}
          onProcessRowUpdateError={(error) => {
            console.error('Error updating BOM row:', error);
            setError(error?.message || 'Failed to update BOM row');
          }}
          slots={{ toolbar: GridToolbar }}
          slotProps={{ toolbar: { csvOptions: { allColumns: true } } }}
        />
      </Box>
      <Box sx={{ mt: 3, width: '100%' }}>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>ECCN/COO cost summary</Typography>
        <Box sx={{ height: 320, width: '100%', mb: 3 }}>
          <DataGrid
            rows={costSummaryMatrix.rows}
            columns={[
              { field: 'COO', headerName: 'COO', width: 180, resizable: true, sortable: true },
              ...costSummaryMatrix.eccnValues.map((eccn) => ({
                field: `ECCN_${eccn}`,
                headerName: eccn || 'Blank',
                width: 170,
                type: 'number',
                resizable: true,
                sortable: true,
                valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(2) : '',
              })),
              {
                field: 'rowTotal',
                headerName: 'Row Total',
                width: 140,
                type: 'number',
                resizable: true,
                sortable: true,
                valueFormatter: (params) => params.value != null ? Number(params.value).toFixed(2) : '',
              },
            ]}
            getRowId={(row) => row.id}
            initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
            pageSizeOptions={[10, 25]}
            disableRowSelectionOnClick
          />
        </Box>
        <Typography variant="subtitle1" sx={{ mb: 1 }}>ECCN/COO cost summary as % of total</Typography>
        <Box sx={{ height: 320, width: '100%' }}>
          <DataGrid
            rows={costSummaryPercentMatrix.rows}
            columns={[
              { field: 'COO', headerName: 'COO', width: 180, resizable: true, sortable: true },
              ...costSummaryPercentMatrix.eccnValues.map((eccn) => ({
                field: `ECCN_${eccn}`,
                headerName: eccn || 'Blank',
                width: 170,
                type: 'number',
                resizable: true,
                sortable: true,
                valueFormatter: (params) => params.value != null ? `${Number(params.value).toFixed(2)}%` : '',
              })),
              {
                field: 'rowTotal',
                headerName: 'Row Total',
                width: 140,
                type: 'number',
                resizable: true,
                sortable: true,
                valueFormatter: (params) => params.value != null ? `${Number(params.value).toFixed(2)}%` : '',
              },
            ]}
            getRowId={(row) => row.id}
            initialState={{ pagination: { paginationModel: { pageSize: 25 } } }}
            pageSizeOptions={[10, 25]}
            disableRowSelectionOnClick
          />
        </Box>
      </Box>
    </Box>
  );
};

const TopMenu = () => {
  const { loggedIn, checkLoginState, user } = useContext(AuthContext);

  const handleLogout = async () => {
    try {
      await axios.post(`${serverUrl}/auth/logout`);
      checkLoginState();
    } catch (err) {
      console.error(err);
    }
  };

  const handleLogin = async () => {
    try {
      const { data: { url } } = await axios.get(`${serverUrl}/auth/url`);
      window.location.assign(url);
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <nav style={{ display: 'flex', gap: '12px', alignItems: 'center', marginBottom: '12px' }}>
      <a href="/">Home</a>
      <a href="/warehouse">Articles</a>
      <a href="/warehouse/productionorders">Production orders</a>
      <a href="/warehouse/purchaseorders">Purchase orders</a>
      <a href="/warehouse/procured-articles">Procued articles</a>
      <a href="/warehouse/missingcomponents">Missing Components</a>
      <a href="/warehouse/bom">BOM</a>
      <div style={{ marginLeft: 'auto' }}>
        {loggedIn === true ? (
          <>
            <span style={{ marginRight: '8px' }}>{user ? user.name : 'User'}</span>
            <button className="btn" onClick={handleLogout}>Logout</button>
          </>
        ) : loggedIn === false ? (
          <button className="btn" onClick={handleLogin}>Login</button>
        ) : null}
      </div>
    </nav>
  );
};



const Productionorders = () => {
  const { loggedIn } = useContext(AuthContext);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (loggedIn !== true) return;
    document.title = 'Production orders - Fortnox';
  }, [loggedIn]);

  useEffect(() => {
    if (loggedIn !== true) return;
    // Fetch data from API
    fetch('/api/warehouse/productionorders')
      .then(response => response.json())
      .then(data => {
        // Set fetched data to rows
        setRows(Array.isArray(data) ? data : (data?.rows ?? data?.ProductionOrders ?? []));
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [loggedIn]);

  if (loggedIn === false) return <Login />;

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 50,
      resizable: true,
      renderCell: (params) => (
        <a href={`/warehouse/productionorder/${params.value}`}>
          {params.value}
        </a>
      ),    
    },
    {
      field: 'itemId',
      headerName: 'Item ID',
      width: 250,
      resizable: true,
    },
    {
      field: 'quantity',
      headerName: 'Quantity',
      type: 'number',
      width: 100,
      resizable: true,
    },
    {
      field: 'startDate',
      headerName: 'Start Date',
      width: 110,
      resizable: true,
    },
    {
      field: 'productionDate',
      headerName: 'Production Date',
      width: 110,
      resizable: true,
    },
    {
      field: 'productionState',
      headerName: 'Production State',
      width: 200,
      resizable: true,
    },
    {
      field: 'documentState',
      headerName: 'Document State',
      width: 200,
      resizable: true,
    },
  ];
  
  return (
    <Box sx={{ height: '90%', width: '90%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

const Purchaseorders = () => {
  const { loggedIn } = useContext(AuthContext);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (loggedIn !== true) return;
    document.title = 'Purchase orders - Fortnox';
  }, [loggedIn]);

  useEffect(() => {
    if (loggedIn !== true) return;
    // Fetch data from API
    fetch('/api/warehouse/purchaseorders')
      .then(response => response.json())
      .then(data => {
        // API may return an array or an object with PurchaseOrders key
        let rowsData = data;
        if (!rowsData) rowsData = [];
        if (rowsData.PurchaseOrders && Array.isArray(rowsData.PurchaseOrders)) {
          rowsData = rowsData.PurchaseOrders;
        } else if (rowsData.PurchaseOrder && !Array.isArray(rowsData)) {
          // single object returned
          rowsData = [rowsData.PurchaseOrder];
        } else if (!Array.isArray(rowsData) && rowsData.rows && Array.isArray(rowsData.rows)) {
          // some endpoints return object with 'rows'
          rowsData = rowsData.rows;
        } else if (!Array.isArray(rowsData) && rowsData.length === undefined) {
          // fallback: wrap single object
          rowsData = [rowsData];
        }
        // Normalize id field (ensure numeric id exists for DataGrid)
        rowsData = rowsData.map(r => ({ ...r, id: r.id || r.Id || r.purchaseOrderId }));
        setRows(rowsData);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [loggedIn]);

  if (loggedIn === false) return <Login />;

  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      width: 90,
      resizable: true,
      renderCell: (params) => (
        <a href={`/warehouse/purchaseorder/${params.value}`}>
          {params.value}
        </a>
      ),
    },
    {
      field: 'supplierName',
      headerName: 'Supplier',
      width: 220,
      resizable: true,
    },
    {
      field: 'supplierNumber',
      headerName: 'Supplier #',
      width: 140,
      resizable: true,
    },
    {
      field: 'orderDate',
      headerName: 'Order Date',
      width: 120,
      resizable: true,
    },
    {
      field: 'deliveryDate',
      headerName: 'Delivery Date',
      width: 120,
      resizable: true,
    },
    {
      field: 'purchaseOrderState',
      headerName: 'State',
      width: 160,
      resizable: true,
    },
    {
      field: 'orderValue',
      headerName: 'Order Value',
      type: 'number',
      width: 140,
      resizable: true,
    },
    {
      field: 'orderValueInSEK',
      headerName: 'Value (SEK)',
      type: 'number',
      width: 140,
      resizable: true,
    },
  ];
  
  return (
    <Box sx={{ height: '90%', width: '90%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

const ProcuedArticles = () => {
  const { loggedIn } = useContext(AuthContext);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (loggedIn !== true) return;
    document.title = 'Procued articles - Fortnox';
  }, [loggedIn]);

  useEffect(() => {
    if (loggedIn !== true) return;
    fetch('/api/warehouse/procured-articles')
      .then(response => response.json())
      .then(data => {
        const rowsData = Array.isArray(data) ? data : [];
        setRows(rowsData.map((r, i) => ({ ...r, _id: `${r.purchase_order_number}-${r.article}-${i}` })));
      })
      .catch(error => console.error('Error fetching procured articles:', error));
  }, [loggedIn]);

  if (loggedIn === false) return <Login />;

  const columns = [
    { field: 'purchase_order_number', headerName: 'Purchase Order #', width: 180, resizable: true },
    { field: 'article', headerName: 'Article', width: 220, resizable: true },
    { field: 'quantity', headerName: 'Quantity', type: 'number', width: 130, resizable: true },
  ];

  return (
    <Box sx={{ height: '90%', width: '90%' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row._id}
        initialState={{ pagination: { paginationModel: { pageSize: 50 } } }}
        pageSizeOptions={[50]}
        disableRowSelectionOnClick
      />
    </Box>
  );
};

const Productionorder = ({ apiEndpoint, pagetitle }) => {
  const rateLimitPerSecond = 5;

  const { loggedIn } = useContext(AuthContext);
  const { orderId } = useParams(); // Access the URL parameter
  const [rows, setRows] = useState([]);
  const [title, setTitle] = useState('');
  const hasFetched = useRef(false);
  const [error, setError] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [accountOptions, setAccountOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    // Reset fetch guard when route params change
    hasFetched.current = false;
  }, [apiEndpoint, orderId]);

  const handleInputChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent the default form submission behavior

    // Here, replace `YOUR_BACKEND_ENDPOINT` with the URL of your JSON backend
    try {
      const response = await fetch('/api/save/stockchanges/', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ date: inputValue }),
      });

      if (response.ok) {
        // Handle successful submission here
        console.log('Data submitted successfully');
        setInputValue('Saved!'); // Optional: clear the input after submission
      } else {
        // Handle errors here
        console.error('Submission failed');
      }
    } catch (error) {
      console.error('Error submitting the form', error);
    }
  };



  useEffect(() => {
    if (loggedIn !== true) return;
    if (hasFetched.current) return;
    hasFetched.current = true;
    // Fetch accounts and order data simultaneously
    const endpointUrl = pagetitle === 'warehouse' ? apiEndpoint : apiEndpoint + orderId;
    Promise.all([
      fetch('/api/accounts').then(response => response.json()),
      fetch(endpointUrl).then(response => response.json())
    ]).then(([accountsData, data]) => {
      setAccountOptions(accountsData);
        const docId = data.id || data.Id || orderId || '';
        // Set title and input date according to document type
        if (pagetitle === 'purchase' || data.supplierName || data.orderDate) {
          const supplier = data.supplierName || data.supplier || '';
          const orderDate = data.orderDate || '';
          setTitle(`${docId} - ${supplier} PO ${orderDate}`.trim());
          setInputValue(data.deliveryDate || data.orderDate || '');
        } else {
          const qty = data.quantity || '';
          const itemUnit = data.itemUnit || '';
          const itemIdVal = data.itemId || '';
          const itemDesc = data.Description || '';
          const start = data.startDate || '';
          setTitle(`${docId} - ${qty} ${itemUnit} ${itemIdVal} ${itemDesc} ${start}`.trim());
          if (data.productionDate != null) {
            setInputValue(data.productionDate)
          } else {
            setInputValue(data.startDate || '')
          }
        }
        const packageItems = Array.isArray(data) ? data : data.packageItems || [];

        if (pagetitle === 'warehouse' && Array.isArray(data)) {
          setTitle('Warehouse');
          setRows(data);
        }

        const fetchWithRetry = async (url, retries = 3) => {
          for (let i = 0; i < retries; i++) {
            try {
              const response = await fetch(url);
              if (response.ok) {
                return await response.json();
              } else if (response.status === 429) {
                // Rate limit, wait and retry
                await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
              } else {
                throw new Error(`HTTP ${response.status}: ${response.statusText}`);
              }
            } catch (error) {
              if (i === retries - 1) throw error;
              await new Promise(resolve => setTimeout(resolve, 1000 * (i + 1)));
            }
          }
        };

        const fetchDetailsInBatch = (batch) => {
          const promises = batch.map(row => {
            if (!row.id) {
              console.error('Undefined row ID:', row);
              return Promise.resolve(null); // Skip this row if id is undefined
            }
            const id = row.id.toString().replace(/\//g, 'SLASH');
//            console.log('fetching ID:',id);
            const fetchPromise = fetchWithRetry(`/api/article/${id}`)
            .then(detailedData => {
              return { ...row, ...detailedData };
            })
            .catch(error => {
              console.error('Error fetching detailed data for row:', row.id, error);
              return { ...row, error: 'Failed to fetch detailed data' }; // Include error info in the row
            });
            return fetchPromise;
          });
     //     console.log('promises',promises);
          Promise.all(promises).then(detailedRows => {
            // Update the state with new rows
            setRows(prevRows => {
              // Create a map to associate ids from array1 to their objects
              let idToObject = {};
              detailedRows.forEach(obj => {
                  idToObject[obj.id] = obj;
              });
              let oldRows = []
              if (prevRows.length == 0) {
                oldRows = packageItems;
              } else {
                oldRows = prevRows;
              }
              // Iterate over array2 and join with array1 based on id
              const joinedRows = oldRows.map(obj => {
                if (idToObject[obj.id]) {
                    const mergedRow = { ...obj, ...idToObject[obj.id] };
                    // Remove cached flags only from rows that were updated
                    Object.keys(mergedRow).forEach(key => {
                      if (key.startsWith('cached_')) {
                        delete mergedRow[key];
                      }
                    });
                    return mergedRow;
                }
                return obj;
              });
      //        console.log('prevRows:', oldRows, 'Detailed Rows:', detailedRows, 'all:',joinedRows);  // Debug log
              return joinedRows;
            });
            // Fetch next batch after a delay
            const nextBatchIndex = packageItems.indexOf(batch[batch.length - 1]) + 1;
            if (nextBatchIndex < packageItems.length) {
              setTimeout(() => {
                fetchDetailsInBatch(packageItems.slice(nextBatchIndex, nextBatchIndex + rateLimitPerSecond));
              }, 1000);
            }
          });
        };
        // Start fetching with the first batch
        fetchDetailsInBatch(packageItems.slice(0, rateLimitPerSecond));
        // Set fetched data to rows
  //      setRows(packageItems);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [apiEndpoint, orderId, loggedIn, pagetitle]);

  useEffect(() => {
    // reflect the per-order title in the browser tab
    if (loggedIn !== true) return;
    const tabTitle = title || (pagetitle === 'warehouse' ? 'Warehouse' : (pagetitle ? `${pagetitle} order ${orderId}` : 'Order'));
    document.title = tabTitle + ' - Fortnox';
  }, [title, pagetitle, orderId, loggedIn]);


  const processRowUpdate = async (newRow, oldRow) => {
    // Perform validation or other checks here
    // ...
    console.log('saveedit',newRow, oldRow);

    try {

      const id_masked = newRow.id.toString().replace(/\//g, 'SLASH');
//      fetch(`/api/update/article/${id_masked}`, {
  

      // Make API call to update the backend
      const response = await fetch(`/api/update/article/${id_masked}`, {
        method: 'POST', // or 'PUT' depending on your API
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({'oldRow':oldRow,'newRow':newRow}),
      });

      if (!response.ok) {
        handleProcessRowUpdateError('Network response was not ok');
        throw new Error('Network response was not ok');
  

      }

      // Clear cached flags for updated fields
      const differences = {};
      for (const key in newRow) {
        if (key in oldRow && newRow[key] !== oldRow[key]) {
          differences[key] = [newRow[key], oldRow[key]];
        }
      }
      for (const key in newRow) {
        if (!(key in oldRow)) {
          differences[key] = [newRow[key], ""];
        }
      }
      const updatedRow = { ...newRow };
      for (const key in differences) {
        updatedRow[`cached_${key}`] = false;
      }

      // Return the updated row to update the DataGrid
      return updatedRow;
    } catch (error) {
      handleProcessRowUpdateError('Error updating row:'+error);
      console.error('Error updating row:', error);
      // Return the old row to revert the changes in the DataGrid
      return oldRow;
    }
  };

  const handleProcessRowUpdateError = (err) => {
    // Handle the error
    console.error('Error in processing row update:', err);
    // Optionally, display a message to the user
    setError(err.message || 'An error occurred while updating the row.');
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const columns = [
    {
      field: 'row_id',
      headerName: 'row',
      width: 50,
      editable: false,
    },
    {
      field: 'po_id',
      headerName: 'production',
      width: 50,
      editable: false,
    },
    {
      field: 'po_name',
      headerName: 'item',
      width: 50,
      editable: false,
    },
    {
      field: 'id',
      headerName: 'ID',
      width: 150,
      renderCell: (params) => (
        <div>
          <a href={`https://apps5.fortnox.se/app/53af0b2876bd4b85843c04986507d5bb/common/item/${params.value}/sub/general-item`}>
            FN
          </a>&nbsp;
          <a href={`/api/article/${params.value}`}>
            {params.value}
          </a>
        </div>
      ),

    },
    {
      field: 'pdf',
      headerName: 'PDF',
      width: 80,
      renderCell: (params) => (
        <Button onClick={() => handleSinglePdfExport(params.row)}>PDF</Button>
      ),
      disableExport: true,
    },
    {
      field: 'print',
      headerName: 'Print',
      width: 80,
      renderCell: (params) => (
        <Button onClick={() => handleSinglePrint(params.row)}>Print</Button>
      ),
      disableExport: true,
    },
    {
      field: 'Description',
      headerName: 'Description',
      width: 250,
      editable: true,
    },
    {
      field: 'po_qty',
      headerName: 'Ordered Qty',
      type: 'number',
      width: 100,
      editable: false,
    },
    {
      field: 'quantityRequired',
      headerName: 'quantity Required',
      type: 'number',
      width: 100,
    },
    {
      field: 'quantityReserved',
      headerName: 'quantity Reserved',
      type: 'number',
      width: 110,
    },
    {
      field: 'totalQuantityRequired',
      headerName: 'total Quantity Required',
      type: 'number',
      width: 110,
    },
    {
      field: 'quantityMissing',
      headerName: 'Quantity Missing',
      type: 'number',
      width: 110,
    },
    {
      field: 'QuantityInStock',
      headerName: 'Quantity In Stock',
      type: 'number',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_QuantityInStock ? 'cachedCell' : '',
    },
    {
      field: 'DisposableQuantity',
      headerName: 'Disposable Quantity',
      type: 'number',
      width: 110,
      cellClassName: (params) => params.row.cached_DisposableQuantity ? 'cachedCell' : '',
    },
    {
      field: 'newQuantityInStock',
      headerName: 'new Quantity In Stock',
      type: 'number',
      width: 110,
      editable: true,
      disableExport: true,
    },
    {
      field: 'extra_amt',
      headerName: 'Extra Amount',
      type: 'number',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_extra_amt ? 'cachedCell' : '',
    },
    {
      field: 'place',
      headerName: 'Place',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_place ? 'cachedCell' : '',
    },
    {
      field: 'place_old',
      headerName: 'Place Old',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_place_old ? 'cachedCell' : '',
    },
    {
      field: 'ECCN',
      headerName: 'ECCN',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_ECCN ? 'cachedCell' : '',
    },
    {
      field: 'HTSUS',
      headerName: 'HTSUS',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_HTSUS ? 'cachedCell' : '',
    },
    {
      field: 'COO',
      headerName: 'COO',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_COO ? 'cachedCell' : '',
    },
/*    {
      field: 'DefaultStockPoint',
      headerName: 'Stock Point',
      width: 110,
      editable: true,
    },*/
    {
      field: 'StockAccount',
      headerName: 'Accnt',
      width: 110,
      editable: true,
      type: 'singleSelect',
      valueOptions: accountOptions,
      disableExport: true,
      cellClassName: (params) => params.row.cached_StockAccount ? 'cachedCell' : '',
    },
    {
      field: 'StockChangeAccount',
      headerName: 'Change accnt',
      width: 110,
      editable: true,
      type: 'singleSelect',
      valueOptions: accountOptions,
      disableExport: true,
      cellClassName: (params) => params.row.cached_StockChangeAccount ? 'cachedCell' : '',
    },
    {
      field: 'PurchasePrice',
      headerName: 'Price',
      type: 'number',
      width: 110,
//      editable: true,
      cellClassName: (params) => params.row.cached_PurchasePrice ? 'cachedCell' : '',
    },
    {
      field: 'comptype',
      headerName: 'Type',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_comptype ? 'cachedCell' : '',
    },
    {
      field: 'value',
      headerName: 'Value',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_value ? 'cachedCell' : '',
    },
    {
      field: 'case',
      headerName: 'Case',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_case ? 'cachedCell' : '',
    },
    {
      field: 'rating',
      headerName: 'Rating',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_rating ? 'cachedCell' : '',
    },
    {
      field: 'precision',
      headerName: 'Precision',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_precision ? 'cachedCell' : '',
    },
    {
      field: 'drift',
      headerName: 'Drift',
      width: 110,
      editable: true,
      cellClassName: (params) => params.row.cached_drift ? 'cachedCell' : '',
    },

    




  ];
  
  const handlePdfExport = async () => {
  //  console.log("pdf1");
    try {
//      console.log("pdf2");
      const response = await axios.post('/api/generate-pdf', { data: rows });
      console.log(rows);
      const blob = new Blob([response.data], { type: 'application/pdf' });
//      console.log("pdf3");
      const link = document.createElement('a');
//      console.log(response);
      link.href = window.URL.createObjectURL(blob);
//      console.log("pdf5");
      link.download = 'table_data_PO'+rows[0]['po_id']+'.pdf';
//      console.log("pdf6");
      link.click();
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const handlePrintAll = async () => {
    try {
      const response = await axios.post('/api/print-pdf', { data: rows });
      console.log('Print request sent:', response.data);
    } catch (error) {
      console.error('Error printing:', error);
    }
  };

  const handleSinglePdfExport = async (row) => {
    try {
      const response = await axios.post('/api/generate-pdf', { data: [row], skip_cover: true });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = `${row.id}.pdf`;
      link.click();
    } catch (error) {
      console.error('Error generating PDF:', error);
    }
  };

  const handleSinglePrint = async (row) => {
    try {
      const response = await axios.post('/api/print-pdf', { data: [row], skip_cover: true });
      console.log('Print request sent:', response.data);
    } catch (error) {
      console.error('Error printing:', error);
    }
  };

  if (loggedIn === false) return <Login />;
  if (loggedIn !== true) return <></>;

  return (
    <>
    <h3>{title}</h3>
    <Box sx={{ height: '90%', width: '90%' }}>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
      >
        <Alert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
          {error}
        </Alert>
      </Snackbar>
      <form onSubmit={handleSubmit} noValidate autoComplete="off">
        <TextField id="datetextfield" label="Date" variant="standard" value={inputValue} onChange={handleInputChange} />
        <Button type="submit" variant="contained">Save stock adjustment</Button>
      </form>
      <Button variant="contained" color="primary" onClick={handlePdfExport} style={{ marginTop: '10px' }}>
        Export labels to PDF
      </Button>
      <Button variant="contained" color="primary" onClick={handlePrintAll} style={{ marginTop: '10px', marginLeft: '10px' }}>
        Print labels
      </Button>
      <DataGrid
        rows={rows}
        columns={columns}
        processRowUpdate={processRowUpdate}
        onProcessRowUpdateError={handleProcessRowUpdateError}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 50,
            },
          },
          columns: {
            columnVisibilityModel: pagetitle === 'purchase'
              ? {
                  po_id: false,
                  po_qty: true,
                  po_name: false,
                  row_id: false,
                  quantityRequired: false,
                  quantityReserved: false,
                  totalQuantityRequired: false,
                  quantityMissing: false,
                }
              : {
                  po_id: false,
                  po_qty: false,
                  po_name: false,
                  row_id: false,
                },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
        slots={{ toolbar: GridToolbar }}
        slotProps={{ toolbar: { csvOptions: { allColumns: true } } }} // Export hidden columns
      />
    </Box>
    </>
  );
};





const Dashboard = () => {
  const { user, loggedIn, checkLoginState } = useContext(AuthContext);
 // const [posts, setPosts] = useState([]);
  useEffect(() => {
    (async () => {
      if (loggedIn === true) {



        try {
  // Get posts from server
//     const response = await axios.get(`${serverUrl}/user/posts`)
//          const { data: { posts } } = await axios.get(`${serverUrl}/user/posts`)
//          console.log(response)
//          console.log(posts)
  //        setPosts(posts);
        } catch (err) {
          console.error(err);
        }



      }
    })();
  }, [loggedIn])

  useEffect(() => {
    document.title = 'Dashboard - Fortnox';
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(`${serverUrl}/auth/logout`);
      // Check login state again
      checkLoginState();
    } catch (err) {
      console.error(err);
    }
  }
  const routes = [
    { path: '/', title: 'Home' },
    { path: '/warehouse', title: 'Articles' },
    { path: '/warehouse/productionorders', title: 'Production orders' },
    { path: '/warehouse/missingcomponents', title: 'Missing Components' },
    { path: '/warehouse/bom', title: 'BOM' },
    { path: '/warehouse/purchaseorders', title: 'Purchase orders' },
    { path: '/warehouse/productionorder/:orderId', title: 'Production order (details)' },
    { path: '/warehouse/purchaseorder/:orderId', title: 'Purchase order (details)' },
  ];

  return (
    <>
      <div>
       <h1>Welcome</h1>
        <p>Root page with useful links to app routes:</p>
        <ul>
          {routes.map(r => (
            <li key={r.path}><a href={r.path} title={r.title}>{r.title} — {r.path}</a></li>
          ))}
        </ul>
      </div>
    </>
  );
}


const Login = () => {
  useEffect(() => {
    document.title = 'Login - Fortnox';
  }, []);
  const handleLogin = async () => {
    try {
      // Gets authentication url from backend server
      const { data: { url } } = await axios.get(`${serverUrl}/auth/url`);
      // Navigate to consent screen
      window.location.assign(url);
    } catch (err) {
      console.error(err);
    }
  }
  return <>
  <h3>Login to Dashboard</h3>
  <button className="btn" onClick={handleLogin} >Login</button>
  </>
}


const Callback = () => {
  const called = useRef(false);
  const { checkLoginState, loggedIn } = useContext(AuthContext);
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'Auth callback - Fortnox';
  }, []);
  useEffect(() => {
    (async () => {
      if (loggedIn === false) {
        try {
          if (called.current) return; // prevent rerender caused by StrictMode
          called.current = true;
          const res = await axios.get(`${serverUrl}/auth/token${window.location.search}`);
          console.log('response: ', res);
          checkLoginState();
          navigate('/');
        } catch (err) {
          console.error(err);
          navigate('/');
        }
      } else if (loggedIn === true) {
        navigate('/');
      }
    })();
  }, [checkLoginState, loggedIn, navigate])
  return <></>
};


const Home = () => {
  const { loggedIn } = useContext(AuthContext);
  if (loggedIn === true) return <Dashboard />;
  if (loggedIn === false) return <Login />
  return <></>;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/auth/callback', // fortnox will redirect here
    element: <Callback />,
  },
  {
    path: '/warehouse', // Articles table
    element: <WarehousePage />,
  },
  {
    path: '/warehouse2', // Articles table
    element: <Productionorder pagetitle="warehouse" apiEndpoint="/api/warehouse" />,
  },
  {
    path: '/warehouse/purchaseorders', // List purchaseorders
    element: <Purchaseorders />,
  },
  {
    path: '/warehouse/procured-articles',
    element: <ProcuedArticles />,
  },
  {
    path: '/warehouse/productionorders', // List productionorders
    element: <Productionorders />,
  },
  {
    path: '/warehouse/missingcomponents', // Missing components
    element: <MissingComponents />,
  },
  {
    path: '/warehouse/bom',
    element: <BomPage />,
  },
  {
    path: '/warehouse/productionorder/:orderId', // List productionorders
    element: <Productionorder pagetitle="production" apiEndpoint="/api/warehouse/productionorder/" />,
  },
/*   {
    path: '/warehouse/purchaseorders',
    element: <Purchaseorders />,
  },*/
  {
    path: '/warehouse/purchaseorder/:orderId',
    element: <Productionorder pagetitle="purchase"  apiEndpoint="/api/warehouse/purchaseorder/" />,
  }
]);
/*
        <!--img src={logo} className="App-logo" alt="logo" />
        <p>
          Edit <code>src/App.js</code> and save to reload.
        </p>
        <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a>
        <p>The current time is {currentTime}.</p-->
*/

function App() {

  useEffect(() => {
    console.log('running');
  }, []);

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="App">
        <header className="App-header">
          <AuthContextProvider>
            <TopMenu />
            <RouterProvider router={router} />

          </AuthContextProvider>

        </header>
      </div>
    </LocalizationProvider>
  );
}

export default App;
